import { useQuery } from '@apollo/client'
import { useIntl } from 'react-intl'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { GET_PROJECT_DOCUMENTS } from 'data/layoutcreator/queries/documents'
import PageList from 'shared/components/PageList'
import LiveCursorWrapper from 'shared/components/PageList/components/LiveCursorWrapper'
import withRoom from 'shared/hocs/withRoom'
import { useLiveUsers } from 'shared/hooks/useLiveUsers'
import AdminLayout from 'shared/layout/Admin'
import Flex from 'shared/ui/Flex'

import Header from './components/Header'

const AdminProject: React.FC = () => {
  const { groupId, projectId } = useParams()
  const { formatMessage } = useIntl()
  const location = useLocation()
  const navigate = useNavigate()

  const isCoverView = location.pathname.includes('/cover')

  const { data } = useQuery(GET_PROJECT_DOCUMENTS, {
    variables: {
      groupId: groupId!,
      projectId: projectId!
    }
  })

  const liveUsers = useLiveUsers()

  const projectDataFields: {
    title: string
    value: string
    hide?: boolean
  }[] = [
    { title: 'ID', value: projectId! },
    {
      title: formatMessage({ id: 'AdminProject.fields.groupId' }),
      value: groupId!
    },
    {
      title: formatMessage({ id: 'AdminProject.fields.pagesCount' }),
      value: data?.projectDocuments.length.toString() || '',
      hide: !data?.projectDocuments
    }
  ]

  const handleViewSwitch = (view: 'content' | 'cover') => {
    if (view === 'content') {
      navigate(`/admin/projects/${groupId}/${projectId}/content`)
    } else {
      navigate(`/admin/projects/${groupId}/${projectId}/cover`)
    }
  }

  return (
    <AdminLayout
      showFullscreenButton={false}
      renderHeaderContent={() => (
        <Header
          liveUsers={liveUsers}
          currentView={isCoverView ? 'cover' : 'content'}
          onViewSwitch={handleViewSwitch}
        />
      )}
    >
      <LiveCursorWrapper>
        <Flex
          direction="column"
          alignItems="flex-start"
          marginTop={30}
        >
          <Flex direction="column" rowGap={3}>
            {projectDataFields.map((item, i) => (
              <span key={i}>
                <strong>{item.title}: </strong>
                <span>{item.value}</span>
              </span>
            ))}
          </Flex>

          <Flex
            width="100%"
            justifyContent="center"
            marginTop={34}
            marginBottom={128}
          >
            <PageList projectId={projectId!} groupId={groupId!} />
          </Flex>
        </Flex>
      </LiveCursorWrapper>
    </AdminLayout>
  )
}

export default withRoom(AdminProject)
